export default {
  title: "",
  subtitle: "Company Update, Details and Search",
  path: "companies_generals",
  paragraphs: [
    "To update a company’s information, you can use the endpoint below:",
    "Note: You can update all fields except for document_number and document_type."
  ],
  request:  {
    method: "PUT",
    endpoint: "/subject/companies/:id",
    payload: {
        "company": {
          "net_monthly_average_income": "20000"
        }
      },
      responses: {
        "data": {
          "updated_at": "2025-07-09T13:51:30.989491",
          "status": "approved",
          "social_name": "Comany Social Name LTDA",
          "rfc_pf": null,
          "required_clearance_level": 1,
          "references": [],
          "phone_number": null,
          "phone_country_code": null,
          "phone_area_code": null,
          "net_monthly_average_income": "20000",
          "inserted_at": "2023-12-11T14:11:02.571103",
          "id": "5fd0aa81-b427-4a29-9968-6491d1d7f8b0",
          "fiscal_country": "Brasil",
          "email": "company@email.com",
          "documents": [],
          "document_type": "cnpj",
          "document_number": "53847358000110",
          "clearance_level": 1,
          "birth_date": null,
          "address_street": null,
          "address_state": null,
          "address_postal_code": null,
          "address_number": null,
          "address_neighborhood": null,
          "address_country": null,
          "address_complement": null,
          "address_city": null
        }
      }
    },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Company UUID"
    }
  ],
   troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'If you try to update document number',
        code:{
                  "errors": {
                      "document_number": [
                          "Cannot change document number"
                      ]
                  }
              },
        solution: 'It is not possible to update the document_number and document_type.'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesGenerals.js